import Keycloak from 'keycloak-js';

import configs from "./constants";


export const keycloak = Keycloak(configs.keycloak);
